import { render, staticRenderFns } from "./DashboardSimUsage.vue?vue&type=template&id=cf23f98a&scoped=true"
import script from "./DashboardSimUsage.vue?vue&type=script&lang=js"
export * from "./DashboardSimUsage.vue?vue&type=script&lang=js"
import style0 from "./DashboardSimUsage.vue?vue&type=style&index=0&id=cf23f98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf23f98a",
  null
  
)

export default component.exports